// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_Sw7","cls2":"PaywallPage-cls2_Fi7 PaywallPage-cls1_Sw7"};